module.exports = __webpack_public_path__ + "img/mini-search.61b5b303.svg";